import { Organization } from "@/model/data/organizations/Organization";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetOrganizationsResData } from "./GetOrganizationsCommand";

const ENDPOINT = "/organizations/getOrganization";

export class GetOrganizationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: any = null;

    constructor(username: string, organizationName: string) {
        super();
        this.params = { username: username, organizationName: organizationName };
    }

    public async execute(): Promise<GetOrganizationsResData> {
        var res = await this.executeCommand(this.params);
        return new GetOrganizationsResData(res);
    }
}
